import { SnackbarProvider } from 'notistack';

import IxoPayAddPaymentMethodWebView from 'components/WebView/IxoPayAddPaymentMethod';

const IxoPayAddPaymentMethod = () => {
  return (
    <SnackbarProvider
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      autoHideDuration={3000}
      maxSnack={1}
    >
      <IxoPayAddPaymentMethodWebView />
    </SnackbarProvider>
  );
};

export default IxoPayAddPaymentMethod;
